import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-730b947e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "architecture",
  class: "architecture py-16 px-5 xl:px-0 md:pt-28 md:pb-36"
}
const _hoisted_2 = { class: "text-white text-2xl mb-5 text-center md:hidden" }
const _hoisted_3 = { class: "flex-row-reverse items-center justify-between ml-auto mr-auto w-full md:flex xl:w-1200px" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "w-full mt-6 md:mt-0 md:w-2/5" }
const _hoisted_6 = { class: "text-white text-2xl mb-5 hidden md:block lg:text-3xl" }
const _hoisted_7 = { class: "architecture-desc text-sm mb-5 md:mb-10" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-white text-lg mb-1 md:mb-3" }
const _hoisted_10 = { class: "tec-item-desc text-sm" }

import { ref, onMounted } from 'vue'
import lottie from 'lottie-web'
import { useI18n } from 'vue-i18n'

// eslint-disable-next-line no-undef
// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  props: {
    windowWidth: null
  },
  setup(__props: any) {

const props = __props as {
  windowWidth: number
}


const { t } = useI18n()
const tecItems = ['coordinator', 'detector', 'watchman']
const activeAnimaItem = ref(tecItems[0])
// eslint-disable-next-line no-unused-vars
const oriLottieInstance = null as any

const handleTecItemClick = (name: string) => {
  activeAnimaItem.value = name
}

onMounted(() => {
  tecItems.forEach((item) => {
    lottie.loadAnimation({
      container: document.getElementById(`architecture-anima-${item}`) as any, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `anima/${item}.json` // the path to the animation json
    })
  })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('architecture.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "relative",
        style: _normalizeStyle(`
          ${__props.windowWidth > 1024 ? 'width: 636px;height: 517px;' : (
            __props.windowWidth > 768 ? 'width: 440px;height: 357px;' : ('width:100%;height:' + (__props.windowWidth - 40) / 636 * 517 + 'px'))
        }
          `)
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tecItems, (item, index) => {
          return _createElementVNode("div", {
            id: `architecture-anima-${item}`,
            key: index,
            class: _normalizeClass(`
            absolute top-0 left-0 w-full h-full
            transition-opacity duration-300
            opacity-${item === activeAnimaItem.value ? '100' : '0'}
            architecture-anima-${item}
          `)
          }, null, 10, _hoisted_4)
        }), 64))
      ], 4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('architecture.title')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('architecture.desc')), 1),
        _createElementVNode("ul", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tecItems, (item, index) => {
            return _createElementVNode("li", {
              key: index,
              class: _normalizeClass(["flex flex-col items-start justify-center box-border p-4 mb-4 cursor-pointer md:p-5 md:mb-5", activeAnimaItem.value === item ? 'active' : '']),
              onClick: ($event: any) => (handleTecItemClick(item))
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)(item)), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)(`${item}_desc`)), 1)
            ], 10, _hoisted_8)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})